// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-light":"#c9c9c9","grey-vlight":"#f6f6f6","icon":"_1YHDJIT","table_wrapper":"_2ETS0Ig"};